import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../store';
import { setIsModalOpen, setModalContent } from '../../../store/slices/global';
import Headline from '../../../ui/Headline';
import Button from '../../../ui/Button';
import ButtonsGroup from '../../../ui/ButtonsGroup';
import { MODAL_CONTENT } from '../../../app.config.vars/modalContent';
import { deleteInstitution, getInstitutions, mapInstitutionsResponse, } from '../../../api/admin/institutions';
import { selectInstitutionsCurrentPage, setInstitutions, } from '../../../store/adminSlices/institutions';
import Loader from '../../../ui/Loader';
import Checkbox from '../../../ui/Checkbox';
import { deleteEditor, getEditors, getEditorsPerInstitution } from '../../../api/admin/editors';
import { selectEditorsCurrentPage, setEditors } from '../../../store/adminSlices/editors';
import ConfirmDeleteAction from '../confirmDeleteAction';
import { useSelector } from 'react-redux';
const ConfirmDeleteAdminUnit = ({ unitId, unit, institutionId, }) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const institutionsCurrentPage = useSelector(selectInstitutionsCurrentPage);
    const editorsCurrentPage = useSelector(selectEditorsCurrentPage);
    const [isConfirm, setIsConfirm] = useState(false);
    const [deleteStatus, setDeleteStatus] = useState(null);
    const deleteAdminUnit = async () => {
        try {
            setDeleteStatus('pending');
            if (unit === 'institution') {
                await deleteInstitution(unitId);
                const institutions = await getInstitutions(institutionsCurrentPage);
                dispatch(setInstitutions(mapInstitutionsResponse(institutions)));
            }
            else {
                await deleteEditor(unitId);
                let editors;
                if (institutionId) {
                    editors = await getEditorsPerInstitution(institutionId, editorsCurrentPage);
                }
                else {
                    editors = await getEditors(editorsCurrentPage);
                }
                dispatch(setEditors(editors.data));
            }
            setDeleteStatus('success');
        }
        catch (error) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.somethingWentWrong.key));
        }
    };
    return (_jsxs(ConfirmDeleteAction, { children: [_jsx("div", { className: "modal-content-title", children: _jsx(Headline, { type: 'h1', title: t(deleteStatus === 'pending'
                        ? `admin.deleting_${unit}`
                        : deleteStatus === 'success'
                            ? `admin.${unit}_was_deleted`
                            : `admin.confirm_delete_${unit}`) }) }), _jsx("div", { className: "modal-content-description", children: deleteStatus === 'pending' ? (_jsx(Loader, {})) : deleteStatus === 'success' ? null : (_jsxs(_Fragment, { children: [_jsx("p", { children: t('admin.irreversible_action') }), _jsx("p", { children: t(`admin.delete_${unit}_consequences`) })] })) }), _jsx("div", { className: "modal-content-checkbox", children: deleteStatus !== 'pending' && deleteStatus !== 'success' && (_jsx(Checkbox, { id: `delete-${unit}-confirmation`, label: t(`label.confirm_delete_${unit}`), checked: isConfirm, onChange: () => setIsConfirm((prev) => !prev), labelColor: '#000' })) }), _jsx("div", { className: `modal-content-button${deleteStatus === 'success' ? '' : ' not-deleted'}`, children: _jsxs(ButtonsGroup, { justify: 'center', children: [deleteStatus === 'success' ? (_jsx(Button, { label: t('button.ok'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            } })) : (_jsx(Button, { label: t('button.cancel'), onClick: () => {
                                dispatch(setIsModalOpen(false));
                                dispatch(setModalContent(null));
                            }, disabled: deleteStatus === 'pending' })), deleteStatus !== 'success' && (_jsx(Button, { variant: 'outlined', label: t(`button.delete_${unit}`), onClick: deleteAdminUnit, disabled: deleteStatus === 'pending' || !isConfirm }))] }) })] }));
};
export default ConfirmDeleteAdminUnit;
